var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"agency-fees-progress-bar"},_vm._l((_vm.progressElements),function(progressElement,index){return _c('div',{key:progressElement.id,class:[
      'agency-fees-progress-bar__element',
      `agency-fees-progress-bar__element_${progressElement.type}`,
      {
        'agency-fees-progress-bar__element_special': _setup.isSpecialDivider(
          progressElement,
          index
        ),
      },
    ]},[_c('span',{staticClass:"divider"}),_c(_setup.AgencyFeesBonusElement,{attrs:{"bonus-element":progressElement}}),_c('span',{staticClass:"divider"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }